/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Attribute Display settings component
 * - allow user to select, unselect attribute to hide/unhide
 * - TODO: Allow reordering of the attributes
 * Component will send the message which will be subscribed by the plot view to make the necessary change
 */

import React from 'react';

// import Dyn from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';
import CheckboxGroup from './common/CheckboxGroup.jsx';
import PlainButton from './common/PlainButton';
import CheckboxListSelection from './common/CheckboxListSelection.jsx';
import Mathjax from './common/Mathjax.js';
class AttributeDisplaySetting extends React.Component {
    constructor(props){
        super(props)
        var attribs = this.props.attribs,
            includedAttribs = [];

        attribs.forEach((attr) => {
            if(attr.isVisible) {
                includedAttribs.push(attr.id);
            }
        });

        // for(var i=1, numAttribs=Dyn.dataSet.getNumAttributes(); i<numAttribs; i++) {
        //     var attr = {
        //         name: Dyn.dataSet.attribs[i].name || Dyn.dataSet.columnNames[i],
        //         columnName: Dyn.dataSet.columnNames[i],
        //         longName: Dyn.dataSet.attribs[i].longName,
        //         id: Dyn.dataSet.columnIds[i],
        //         rawAttr: Dyn.dataSet.attribs[i]
        //     };
        //     attribs.push(attr);
        //
        //     // Managing the checkboxes based on the current visibility
        //     var attrObj = Dyn.dataSet.getAttributeByID(attr.id);
        //     if ( attrObj.isVisible ){
        //         includedAttribs.push(Dyn.dataSet.columnIds[i]);
        //     }
        // }
        // mediator.subscribe( "plot:containerResized", this.handleUnmountFilter );
        // mediator.subscribe( "toolBar:closeCurrentAttributeFilter", this.cleanFilter);
        // "plot:containerResized" - subscribe to it and handle the unmountFilter
        // attributeObj.stats.isNumeric() ? "numerical" : "categorical",
        this.state = {
            attributeList: attribs,
            value: includedAttribs
        };
    }

    handleUnmountFilter = () => {
        // // Unmount it only if its smaller case card mode
        // if (!$("#chartArea").hasClass("slideLeft")){
        //     this.unmountFilter();
        //
        //     // Keep the state of the case card
        //     var record = {
        //         object: "filter",
        //         disableToggle: true
        //     };
        //
        //     mediator.publish( "card:reinstateCaseCard", record );
        // }
    }

    cleanFilter = () => {
        // unmount the react filter component
        // this.unmountFilter();
    }

    unmountFilter = () => {
        // Use the same Id as whats been used to render the
        // react component for the container
        // var node = document.getElementById("caseDiv");

        // mediator.remove( "plot:containerResized", this.handleUnmountFilter );

        // It will unmount the component from the memory
        // var unmountNode = ReactDOM.unmountComponentAtNode(node);
        // console.log(unmountNode);
    }

    // select all the checkboxes
    handleSelectAll = () => {
        var checkboxes = this.refs.attributeGroup.getCheckboxes();
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = true;
        }
        this.handleChange();
    }

    // uncheck all the checkboxes
    handleClear = () => {
        var checkboxes = this.refs.attributeGroup.getCheckboxes();
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false;
        }
        this.handleChange();
    }

    handleChange = () => {

        // will return the currently selected checkbox values as an array, possibly empty
        var hiddenAttributes = this.refs.attributeGroup.getUncheckedValues();

        this.setState({
          value: this.refs.attributeGroup.getCheckedValues()
        }, function() {
            this.props.onAttributesHidden(hiddenAttributes);
            // publish message to update the cases in plot and in legend area
            // mediator.publish("records:updateAttributesDisplay", {
            //     "attributes": hiddenAttributes
            // });
        });
    }

    handleClose = (event) => {
        // To close the current view
        this.props.onClose();
        // unmount the react filter component
        // this.unmountFilter();

        // TODO - Revert back to the case cards - Check for selected attribute
        // var record = { object: "filter", caseCardScrollTop: this.props.caseCardScrollTop };
        // mediator.publish( "card:reinstateCaseCard", record );
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    // To listen the keypress on the component
    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    handleToggleCategories = (isChecked) => {
        isChecked ? this.handleClear() : this.handleSelectAll();
    }


    componentDidMount = () => {
        this.refs.closeButton.focus();
    }

    render = () => {
        // render the add new attribute component
        // style={{textAlign:'right'}}
        return (
            <div className="tde-fill" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
                <div className="tde-sliding-panel-header tde-divider-bottom">
                    <div>
                        <span
                            className={"tde-ml-2 tde-h6 tde-font-weight-bold" + (this.props.reduceCaseCardWidth ? '':' tde-mr-6')}
                            role="heading"
                            aria-level="1">{ this.getLoc('ATTRIBUTE DISPLAY SETTINGS CARD') }</span>
                    </div>
                    <PlainButton title="Close" ref="closeButton" aria-label={this.getLoc('Close Attribute Display Settings')} onClick={this.handleClose} className="tde-mx-2 tde-close-attr-settings"><i className="tde-i tde-i-remove"></i></PlainButton>
                </div>
                <div className={"tde-sliding-panel-body tde-attribute-display-settings-body tde-card-content-bg-color tde-pl-2" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                   <div className="tde-s1 tde-font-weight-semibold tde-attr-name tde-my-3">
                        <CheckboxListSelection
                            lableStr={this.getLoc('Select all')}
                            checkboxListStatus={this.state.value.length === this.state.attributeList.length
                                                ? 'all': this.state.value.length === 0
                                                ? 'none' : 'partial' }
                            checkboxOnClick={this.handleToggleCategories}
                            showClearButton = {true}
                            selectedIems = {this.state.value.length}
                            handleClear = {this.handleClear}
                            getLoc = {this.getLoc}
                        />
                    </div>
                    <div className="tde-checkbox-section tde-pl-0">
                        <CheckboxGroup
                        name="attributes"
                        value={this.state.value}
                        ref="attributeGroup"
                        onChange={this.handleChange}>
                            { this.state.attributeList.map(function(item, i) {
                                let props = {};
                                /*
                                // To autofocus the first element
                                if(i === 0) {
                                    props.ref = (ele) => {ele && ele.focus()}
                                } */
                                return <label key={i}><input key={i} {...props} type="checkbox" className="tde-mr-2 tde-ml-0" aria-label={item.name} value={ item.id }/>
                                    <span className='tde-word-break'><Mathjax value={item.name} /></span></label>;
                            }.bind(this)) }
                        </CheckboxGroup>
                    </div>
                </div>
            </div>
        );
    }
}

export default AttributeDisplaySetting
